"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getState_1 = require("../../helpers/getState");
const isEmptyObject_1 = tslib_1.__importDefault(require("../../helpers/isEmptyObject"));
function addReplaceStateWithSameVersion(allStates, state) {
    if (isEmptyObject_1.default(state)) {
        return;
    }
    const contentId = state.contentId;
    const userId = state.userId;
    const existingStateIndex = getState_1.getIndexOfStateByContentIdUserId(allStates, contentId, userId);
    if (existingStateIndex > -1) {
        const existingState = allStates[existingStateIndex];
        // otherwise reset progress won't work
        const { versionNumber, versionId } = existingState;
        allStates[existingStateIndex] = Object.assign({}, state, { versionNumber, versionId });
    }
    else {
        allStates.push(state);
    }
}
exports.default = addReplaceStateWithSameVersion;
//# sourceMappingURL=addReplaceStateWithSameVersion.js.map